import HeroSection from "./HeroSection"
import { Box, Button, Grid, Typography } from "@mui/material";
import SubscribeSection from "../HomeScreen/SubscribeSection"
const FeaturesScreen=()=>{
    return(
        <>
        <Box>
            <HeroSection/>
        </Box>
        {/* <Box>
            <SubscribeSection/>
        </Box> */}
        </>
    )
}
export default FeaturesScreen